import React from 'react'

import AprovadosImg from '../../assets/Aprovados2025.jpg'

function Aprovados2025() {
  return (
    <figure>
      <img src={AprovadosImg} alt='Aprovados 2025' style={{ width: '100%' }} />
    </figure>
  )
}

export default Aprovados2025